module.exports = __webpack_public_path__ + "img/sepa.ebbf7598.svg";